import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function (n) {
  return _pushScopeId("data-v-19206142"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = {
  class: "notice-content"
};
var _hoisted_2 = {
  class: "notice-floor"
};
var _hoisted_3 = {
  class: "title"
};
var _hoisted_4 = {
  class: "content"
};
var _hoisted_5 = /*#__PURE__*/_withScopeId(function () {
  /*#__PURE__*/return _createElementVNode("section", {
    class: "notice-floor"
  }, [/*#__PURE__*/_createElementVNode("div", {
    class: "content"
  }, [/*#__PURE__*/_createElementVNode("ol", {
    class: "info-order-list"
  }, [/*#__PURE__*/_createElementVNode("li", null, " 我是自愿报名参加本次大赛，所有提交的个人信息均为真实有效。 "), /*#__PURE__*/_createElementVNode("li", null, " 我将亲自参加所有比赛环节，保证比赛过程中的所有作品、答题等均为本人独立完成，不借助任何外力，不抄袭装他人作品。 "), /*#__PURE__*/_createElementVNode("li", null, " 我了解并同意遵守大赛的所有规则和条款，包括但不限于比赛规程、评分标准和知识产权声明。 "), /*#__PURE__*/_createElementVNode("li", null, " 若我违反比赛规则，包括但不限于替考、作弊等行为，我愿意承担由此产生的一切后果，并无条件服从组委会的处理决定。 "), /*#__PURE__*/_createElementVNode("li", null, " 我同意组委会在必要时对我的参赛资格进行审查，并提供相应的证明材料。 "), /*#__PURE__*/_createElementVNode("li", null, [/*#__PURE__*/_createTextVNode(" 我保证在比赛期间，所使用的电脑操作系统不低于 "), /*#__PURE__*/_createElementVNode("span", {
    class: "underline"
  }, "Windows7"), /*#__PURE__*/_createTextVNode(" ，Chrome浏览器版本不低于 "), /*#__PURE__*/_createElementVNode("span", {
    class: "underline"
  }, "80.0"), /*#__PURE__*/_createTextVNode(" ；内存不低于8G；CPU不低于酷睿 "), /*#__PURE__*/_createElementVNode("span", {
    class: "underline"
  }, "i5"), /*#__PURE__*/_createTextVNode(" ；硬盘空间：C盘(或系统盘)有 "), /*#__PURE__*/_createElementVNode("span", {
    class: "underline"
  }, "4G"), /*#__PURE__*/_createTextVNode(" 以上剩余空间； 摄像头、麦克风、扬声器设备均可正常使用，以确保比赛过程中网页加载，作答等操作能够顺利进行。若 因自身设备或网络问题影响比赛成绩，我将自行负责。 ")])])])], -1);
});
var _hoisted_6 = {
  class: "footer"
};
var _hoisted_7 = /*#__PURE__*/_withScopeId(function () {
  /*#__PURE__*/return _createElementVNode("div", {
    class: "footer-tips"
  }, null, -1);
});
var _hoisted_8 = {
  class: "action-area"
};
var _hoisted_9 = /*#__PURE__*/_createTextVNode("暂不答题");
var _hoisted_10 = /*#__PURE__*/_createTextVNode(" 我已阅读，并同意以上内容 ");
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_a_spin = _resolveComponent("a-spin");
  var _component_a_button = _resolveComponent("a-button");
  var _component_a_modal = _resolveComponent("a-modal");
  return _openBlock(), _createBlock(_component_a_modal, {
    width: "800px",
    visible: _ctx.data.visible,
    "onUpdate:visible": _cache[0] || (_cache[0] = function ($event) {
      return _ctx.data.visible = $event;
    }),
    title: _ctx.data.commitmentLetterTitle || '比赛须知',
    "mask-closable": false
  }, {
    footer: _withCtx(function () {
      return [_createElementVNode("div", _hoisted_6, [_hoisted_7, _createElementVNode("div", _hoisted_8, [_createVNode(_component_a_button, {
        onClick: _ctx.onClose
      }, {
        default: _withCtx(function () {
          return [_hoisted_9];
        }),
        _: 1
      }, 8, ["onClick"]), _createVNode(_component_a_button, {
        type: "primary",
        onClick: _ctx.onStartExamButtonClick
      }, {
        default: _withCtx(function () {
          return [_hoisted_10];
        }),
        _: 1
      }, 8, ["onClick"])])])];
    }),
    default: _withCtx(function () {
      return [_createVNode(_component_a_spin, {
        size: "large",
        tip: "正在加载数据中...",
        spinning: _ctx.loading,
        delay: 200
      }, {
        default: _withCtx(function () {
          return [_createElementVNode("div", _hoisted_1, [_createElementVNode("section", _hoisted_2, [_createElementVNode("div", _hoisted_3, "本人" + _toDisplayString(_ctx.data.userName) + "：", 1), _createElementVNode("div", _hoisted_4, [_createElementVNode("p", null, " 在此郑重承诺参加" + _toDisplayString(_ctx.data.contestInfoName) + "。我保证以下内容真实无误: ", 1)])]), _hoisted_5])];
        }),
        _: 1
      }, 8, ["spinning"])];
    }),
    _: 1
  }, 8, ["visible", "title"]);
}